import { Component, ElementRef, EventEmitter, HostBinding, HostListener, Input, Output, Renderer2 } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';

import { environment } from 'environments/environment';

import * as moment from 'moment';

export const DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY'
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@Component({
  selector: 'app-input-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]},
    {provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS},
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: DatepickerComponent,
      multi: true
    },
    {provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: {useUtc: true}}
  ]
})
export class DatepickerComponent implements ControlValueAccessor {

  @Input() label: string;
  @Input() placeholder: string;
  @Input() formControl: FormControl;
  @Input() isDisabled = false;
  @Input() required = false;
  @Input() maxDate;
  @Input() minDate;
  @Input() dateFilterFn;
  @Input() startView = 'month';
  @Input() showClear = false;
  @Input() reactive = false;
  @Input() showValidations = false;

  @Output() dateChange = new EventEmitter<any>();

  @Input()
  set value(value) {
    this.selectedDate = value ? moment(value, environment.formatDate) : null;
  }

  get value() {
    return this.selectedDate;
  }

  @HostBinding('class.reactive') get isReactive() {
    return this.reactive;
  }

  get hasValue() {
    return !!this.rawSelectedDate;
  }

  screenWidth: any;

  private onChangeCallback: (_: any) => {};
  private onTouchedCallback: (_: any) => {};

  private selectedDate = null;
  private rawSelectedDate = null;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {
    this.getScreenSize();
  }


  @HostListener('window:resize', ['$event'])
  getScreenSize() {
    this.screenWidth = window.innerWidth;
  }

  writeValue(value) {
    this.selectedDate = value ? moment(value, environment.formatDate) : null;
  }

  registerOnChange(fn) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn) {
    this.onTouchedCallback = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.renderer.setProperty(this.elementRef, 'disabled', isDisabled);
  }

  onDateChange(event) {
    const time = event.value ? event.value.toISOString() : null;

    this.selectedDate = event.value;
    this.rawSelectedDate = time;

    if (this.onChangeCallback) {
      this.onChangeCallback(time);
    }
    if (this.onTouchedCallback) {
      this.onTouchedCallback(time);
    }

    this.dateChange.emit(time);
  }

  onClearDate(event) {
    this.selectedDate = {};
    this.onDateChange(this.selectedDate);
    event.stopPropagation();
  }

  get showErrors() {
    if (!this.formControl) {
      return false;
    }
    return this.formControl.invalid && this.formControl.touched;
  }
}
